/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */
'use strict';

module.exports = {
  func: {
    color: '#147b6a',
  },

  attr: {
    color: '#666',
  },

  object: {
    color: 'rgb(33, 33, 33)',
  },

  array: {
    color: 'rgb(33, 33, 33)',
  },

  symbol: {
    color: '#1c00cf',
  },

  date: {
    color: 'rgb(33, 33, 33)',
  },

  number: {
    color: '#1c00cf',
  },

  string: {
    color: '#c41a16',
    wordBreak: 'breakword',
  },

  bool: {
    color: '#1c00cf',
  },

  empty: {
    color: '#777',
  },
};



/** WEBPACK FOOTER **
 ** /Users/gaearon/p/react-devtools/frontend/value-styles.js
 **/